// /* eslint-disable max-lines */
import React, { useState, useCallback, useEffect, useContext } from 'react';
import _ from 'lodash';
import axios from 'axios';
import { styled } from '@this/constants/themes';
import type { RouteComponentProps } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import type { Moment } from 'moment';
import moment from 'moment';
import type { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { Box, CircularProgress, Typography, Button } from '@material-ui/core';
import {
  CalendarToday as CalendarTodayIcon,
  AccessTime as AccessTimeIcon,
  Place as PlaceIcon
} from '@material-ui/icons';
// import Calendar, { CalendarArgs } from '@this/domain/appoint/calendar';
import Candidate from '@this/domain/appoint/candidate';
// import Event, { EventResponse, convertEventResponseToArgs } from '@this/domain/appoint/event';
import AppointContext from '@this/components/appoint/appoint_context';
import muiTheme from '@this/components/appoint/mui_theme';
import Utils from '@this/domain/appoint/utils';
import type { OpenMeetingResponseArgs } from '@this/domain/appoint/open_meeting';
import OpenMeeting, { convertOpenMeetingResponseToArgs } from '@this/domain/appoint/open_meeting';
import type { OpenMeetingBookingResponseArgs } from '@this/domain/appoint/open_meeting_booking';
import type { CalendarArgs } from '@this/domain/appoint/calendar';
import Calendar from '@this/domain/appoint/calendar';
import BigCalendar from './show_big_calendar';
import { H2, Wrapper, Left, Right, ButtonWrapper, ButtonProgress } from '../../common';
// import { AuthBackdrop, TheReAuthButton } from '../new/new';
import OpenMeetingShowCandidateArea from './candidate_area';
import FixAdjustmentDialog from '../../shared/fix_adjustment_dialog/fix_adjustment_dialog';
import type { DestinationInfo } from '../../shared/fixed_adjustment_dialog/fixed_adjustment_dialog';

interface Props extends RouteComponentProps<{ key?: string }> {
  // handleAdjustmentChange?: () => void;
  setFixWithCalendar: (v: boolean | null) => void;
}

// interface Response {
//   primary_calendar_id: string;
//   calendars: CalendarArgs[];
//   disconnected_accounts: { email: string; message: string | null }[];
//   is_preview: boolean;
//   adjustment: AdjustmentResponseArgs;
//   calendar_connected: boolean;
//   link_aitravel: boolean;
//   add_to_calendar_url?: string;
//   download_ics_url?: string;
//   return_url: string;
// }

// interface AuthoritiesResponse {
//   is_owner: boolean;
// }

// interface EventsResponse {
//   events: EventResponse[][];
// }

interface ParticipantInfo {
  name: string;
  email: string;
}

interface ResponseArgs {
  open_meeting: OpenMeetingResponseArgs;
  calendars: CalendarArgs[];
  primary_calendar: CalendarArgs;
  is_owner: boolean;
  calendar_connected: boolean;
}

interface SubmitParams {
  start_time: string;
  end_time: string;
  participants: ParticipantInfo[];
  share_destinations?: DestinationInfo[];
}

const OpenMeetingsShow = observer(({ setFixWithCalendar, match, location }: Props) => {
  const contextValue = useContext(AppointContext);
  const history = useHistory();
  const [openMeeting, setOpenMeeting] = useState<OpenMeeting | undefined>(undefined);
  const [openMeetingError, setOpenMeetingError] = useState<string | null>(null);
  const [isLoadingOpenMeeting, setIsLoadingOpenMeeting] = useState<boolean>(false);
  // const [adjustment, setAdjustment] = useState<Adjustment | null>(null);
  // const [calendars, setCalendars] = useState<Calendar[]>([]);
  // const [disconnectedAccounts, setDisconnectedAccounts] = useState<{ email: string; message: string | null }[]>(
  //   []
  // );
  // const [eventLists, setEventLists] = useState<Event[][]>([[]]);
  const [selectedCandidate, setSelectedCandidate] = useState<Candidate | null | undefined>(undefined);
  const [isOwner, setIsOwner] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  // const [needReAuth, setNeedReAuth] = useState<boolean>(false);
  const [submitError, setSubmitError] = useState<string | null>(null);
  const [date, setDate] = useState<Moment>(moment());
  const [selectedDate, setSelectedDate] = useState<MaterialUiPickersDate>(null);
  // const [isEventLoading, setIsEventLoading] = useState<boolean>(false);
  const [calendarConnected, setCalendarConnected] = useState<boolean>(false);
  const [selectedParticipants, setSelectedParticipants] = useState<Calendar[]>([]);
  const [showConfirmDialog, setShowConfirmDialog] = useState<boolean>(false);
  // const [showPromotionDialog, setShowPromotionDialog] = useState<boolean>(false);

  // // カレンダーが月曜始まりなので、startMomentには「今週の月曜日」を表示したい。
  // // 2021/06/06(日)時点では、2021/05/31(月)をstartMomentにセットしたい。
  // // 2021/06/07(月)時点では、2021/06/07(月)をstartMomentにセットしたい。
  // // day(1)は、曜日番号を1に変更するだけなので、日曜日(0)から見て前週の月曜日を取得するためには、
  // // 1日戻る必要があるためsubtract(1, 'days')を設定している。
  // const startMoment = date
  //   .clone()
  //   .subtract(1, 'days')
  //   .day(1);
  // const endMoment = startMoment.clone().add(6, 'days');
  // const startDate = startMoment.format('YYYY-MM-DD');
  // const endDate = endMoment.format('YYYY-MM-DD');

  const getParams = new URLSearchParams(window.location.search);
  // const paramRefApp = getParams.get('ref_app');
  // const paramOrgnzID = getParams.get('organization_id');
  // const paramAppID = getParams.get('application_id');
  let defaultSlotStart: string = getParams.get('selectedSlot') || '';

  const key = match.params.key || location.hash.replace(/^#/, '');

  // const setCreatedMessageOnSnackbar = (title: string) => {
  //   location.hash = '';
  //   contextValue.setSnackbarContent({
  //     message: `候補日時を登録しました。\n「【調整中】${title}」という名前で予定を参加者のカレンダーに登録しました。`,
  //     severity: 'success'
  //   });
  //   contextValue.setOpenSnackbar(true);
  // };

  const fetchOpenMeeting = useCallback(() => {
    setIsLoadingOpenMeeting(true);
    setOpenMeetingError(null);
    setFixWithCalendar(false);
    axios
      .get<ResponseArgs>(`/aicalendar/open_meetings/${key}.json`)
      .then(res => {
        const data = res.data;
        const om = new OpenMeeting(convertOpenMeetingResponseToArgs(data.open_meeting));
        setOpenMeeting(om);
        setIsOwner(data.is_owner);
        setCalendarConnected(data.calendar_connected);
        const calendars = data.calendars.map(c => new Calendar(c));
        const primary = data.primary_calendar || calendars ? calendars[0] : null;
        if (primary) {
          setSelectedParticipants([primary]);
        }
        // const authority = res.data;
        // setIsOwner(authority.is_owner);
        // const locationSearch = location.search;
        // const adjRes = await axios.get<Response>(`/aicalendar/adjustments/${key}.json${locationSearch}`);
        // const data = adjRes.data;
        // const args = convertAdjustmentResponseToArgs(data.adjustment);
        // setNeedReAuth(data.disconnected_accounts.length > 0);
        // const calendars = data.calendars.map(c => new Calendar(c));
        // setCalendars(calendars);
        // setDisconnectedAccounts(data.disconnected_accounts);
        // if (authority.is_owner) {
        //   Utils.trackEvent('[cal][view] adjustments show (as organizer)');
        // } else {
        //   Utils.trackEvent('[cal][view] adjustments show (as guest)');
        // }
        // const fetchedAdjustment = new Adjustment(args);
        // setAdjustment(fetchedAdjustment);
        const defaultDate = om ? om.candidates[0].start : moment();
        // const dateParam = locationSearch?.match(/selectedSlot=\d{4}-\d{2}-\d{2}/);
        // if (dateParam) {
        //   const dateString = dateParam[0].replace('selectedSlot=', '');
        //   if (fetchedAdjustment.candidates.find(c => c.start.format('YYYY-MM-DD') === dateString)) {
        //     defaultDate = moment(dateString);
        //   }
        // }
        setDate(defaultDate);
        setSelectedDate(defaultDate);
        // setCalendarConnected(data.calendar_connected);
        // const primary = calendars.find(c => c.id === data.primary_calendar_id) || null;
        // if (primary) {
        //   setSelectedParticipants([primary]);
        // }
        // setShowPromotionDialog(!authority.is_owner && !calendarConnected && !fetchedAdjustment.adjusting);
        // setIsLoading(false);
        // if (location.hash === '#new') {
        //   setCreatedMessageOnSnackbar(fetchedAdjustment.title);
        // }
      })
      .finally(() => setIsLoadingOpenMeeting(false))
      .catch(() => setOpenMeetingError('通信エラーが発生しました。時間をおいて再度お試しください。'));
  }, [key]);

  // マウント時に1回発動
  useEffect(() => {
    fetchOpenMeeting();
  }, []);

  // const fetchEvents = useCallback(async () => {
  //   if (!adjustment) {
  //     return;
  //   }
  //   setIsEventLoading(true);
  //   const participants = isOwner ? adjustment.participants : selectedParticipants;
  //   const params = {
  //     calendars: participants.map(p => (p ? { id: p.id, provider: p.provider } : null)),
  //     from: startDate,
  //     to: endDate
  //   };
  //   if (params.calendars.length > 0) {
  //     const res = await axios.get<EventsResponse>('/aicalendar/events.json', { params });
  //     const data = res.data;
  //     setEventLists(data.events.map(evts => evts.map(e => new Event(convertEventResponseToArgs(e)))));
  //   }
  //   setIsEventLoading(false);
  // }, [adjustment ? adjustment.participants : null, contextValue.user, selectedParticipants, startDate, endDate]);

  const toggleSelectedCandidate = (candidate: Candidate) => {
    setSelectedCandidate(
      selectedCandidate && selectedCandidate.start.format() === candidate.start.format() ? null : candidate
    );
  };

  // useEffect(() => {
  //   fetchEvents();
  // }, [contextValue.user, selectedParticipants, startDate, endDate]);

  // const isInputShareDestination = () => {
  //   const legAddress = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}.[A-Za-z0-9]{1,}$/;
  //   if (
  //     destinationName1.length === 0 ||
  //     destinationMailAddress1.length === 0 ||
  //     !legAddress.test(destinationMailAddress1)
  //   ) {
  //     return false;
  //   }
  //   if (
  //     (destinationName2.length > 0 && destinationMailAddress2.length === 0) ||
  //     (destinationName2.length === 0 && destinationMailAddress2.length > 0) ||
  //     (destinationName2.length > 0 &&
  //       destinationMailAddress2.length > 0 &&
  //       !legAddress.test(destinationMailAddress2))
  //   ) {
  //     return false;
  //   }
  //   if (
  //     (destinationName3.length > 0 && destinationMailAddress3.length === 0) ||
  //     (destinationName3.length === 0 && destinationMailAddress3.length > 0) ||
  //     (destinationName3.length > 0 &&
  //       destinationMailAddress3.length > 0 &&
  //       !legAddress.test(destinationMailAddress3))
  //   ) {
  //     return false;
  //   }
  //   return true;
  // };

  const handleConfirmDialogToggle = (v: boolean) => {
    setShowConfirmDialog(v);
    setFixWithCalendar(v ? null : false);
  };

  const handleSubmit = (destinationName: string, destinationMailAddress: string) => {
    if (!selectedCandidate || !openMeeting) {
      return;
    }
    Utils.trackEvent('[cal][click] fix open meeting');
    setIsSubmitting(true);
    setSubmitError(null);

    const params: SubmitParams = {
      start_time: selectedCandidate.start.format(),
      end_time: selectedCandidate.end.format(),
      participants: [{ name: destinationName, email: destinationMailAddress }]
    };
    if (!isOwner && calendarConnected) {
      params.participants = params.participants.concat(
        selectedParticipants.map(p => ({ name: p.name, email: p.id }))
      );
    }
    axios
      .post<OpenMeetingBookingResponseArgs>(`/aicalendar/open_meetings/${key}/bookings.json`, params)
      .then(res => {
        setShowConfirmDialog(false);
        setFixWithCalendar(null);

        // `/aicalendar`を頭につけるとreact-router側の設定と二重になってしまう
        history.push(`/open_meetings/${key}/bookings/${res.data.key}`);
      })
      .finally(() => {
        setIsSubmitting(false);
      })
      .catch(() => setSubmitError('通信エラーが発生しました。時間をおいて再度お試しください。'));
  };

  //
  // 以下、stateから計算しているだけのもの。どっかでstore化した方がよさそう
  //
  const slotsForCandidate = (candidate: Candidate) => {
    const slots: Candidate[] = [];
    if (openMeeting) {
      let count = 0;
      const stepMinutes = 30;
      let slotStart = candidate.start.clone();
      while (true) {
        const slotEnd = slotStart.clone().add(openMeeting.duration, 'minutes');
        if (slotEnd > candidate.end) {
          break;
        }
        slots.push(new Candidate({ start: slotStart, end: slotEnd }));
        if (count === 0 && ![30, 0].includes(slotStart.minutes())) {
          let minutes = slotStart.minutes();
          if (minutes < 30) {
            minutes = 30 - minutes;
          } else {
            minutes = 60 - minutes;
          }
          slotStart = slotStart.clone().add(minutes, 'minutes');
        } else {
          slotStart = slotStart.clone().add(stepMinutes, 'minutes');
        }
        count += 1;
      }
      if (![30, 0].includes(candidate.end.minutes())) {
        slots.push(
          new Candidate({
            start: candidate.end.clone().subtract(openMeeting.duration, 'minutes'),
            end: candidate.end
          })
        );
      }
    }
    return slots;
  };

  let candidateSlots: Candidate[] = [];
  if (openMeeting) {
    let selectedCandidates = openMeeting.candidates.filter(c => {
      return selectedDate && c.start.format('YYYY-MM-DD') === selectedDate.format('YYYY-MM-DD');
    });
    if (selectedCandidates.length === 0 || contextValue.isMobile) {
      selectedCandidates = openMeeting.candidates;
    }

    candidateSlots = selectedCandidates
      .sort((a, b) => a.start.diff(b.start))
      .map(candidate => {
        return slotsForCandidate(candidate);
      })
      .flat();
    if (defaultSlotStart.length > 0 && selectedCandidate === undefined) {
      const splitSelectedCandidate = defaultSlotStart.split('-');
      let formatCandidateStart = 'YYYY-MM-DD_HH:mm';
      if (splitSelectedCandidate.length === 2) {
        defaultSlotStart = splitSelectedCandidate[0];
        formatCandidateStart = 'YYYYMMDDHHmm';
      }
      setSelectedCandidate(
        candidateSlots.find(s => s.start.format(formatCandidateStart) === defaultSlotStart) || null
      );
    }
  }

  const handleSelectedDateChange = (date: MaterialUiPickersDate) => {
    if (date === null) {
      return;
    }

    setSelectedDate(date);
    setDate(date);
  };

  // const renderPromotionDialog = () => (
  //   <PromotionWrap style={{ display: `${showPromotionDialog ? 'flex' : 'none'}` }}>
  //     <Paper style={{ position: 'relative', margin: 'auto', maxWidth: '230px', padding: '30px' }}>
  //       <IconButton
  //         size="small"
  //         onClick={() => setShowPromotionDialog(false)}
  //         style={{ position: 'absolute', top: 4, right: 4, zIndex: 10 }}
  //       >
  //         <CloseButton />
  //       </IconButton>
  //       <Box>
  //         <img src="/images/aicalendar/adjustment_promotion1.png" width="230" height="154" />
  //       </Box>
  //       <Box>
  //         <PromotionTit style={{ margin: '15px 0 10px' }}>
  //           自分の予定と候補日を一緒にカレンダーに表示しませんか？
  //         </PromotionTit>
  //         <PromotionTxt>
  //           AIカレンダーに登録すると候補日と同時にあなたの予定をカレンダーに表示できます。
  //         </PromotionTxt>
  //         <PromotionTxtSub>第三者に閲覧されることはありません。</PromotionTxtSub>
  //       </Box>
  //       <Box style={{ marginTop: '12px', textAlign: 'center' }}>
  //         <Button
  //           variant="outlined"
  //           color="primary"
  //           href={history.createHref({ pathname: '/users/sign_up' })}
  //           target="_blank"
  //           style={{ fontSize: '11px' }}
  //         >
  //           AIカレンダーにログイン/登録
  //           <span style={{ fontSize: '9px' }}>（無料）</span>
  //         </Button>
  //       </Box>
  //     </Paper>
  //   </PromotionWrap>
  // );

  const renderCandidatesArea = () => {
    return openMeeting ? (
      <OpenMeetingShowCandidateArea
        openMeeting={openMeeting}
        candidateSlots={candidateSlots}
        selectedCandidate={selectedCandidate}
        setSelectedCandidate={setSelectedCandidate}
        selectedDate={selectedDate}
        setSelectedDate={handleSelectedDateChange}
        toggleSelectedCandidate={toggleSelectedCandidate}
      />
    ) : null;
  };

  const renderBigCalendar = () => (
    <BigCalendar
      // eventLists={eventLists}
      candidates={openMeeting ? openMeeting.candidates : []}
      candidateSlots={openMeeting ? _.flatten(_.map(openMeeting.candidates, c => slotsForCandidate(c))) : []}
      selectedCandidate={selectedCandidate}
      // calendars={calendars}
      date={date}
      onDateChange={date => setDate(date)}
      // isEventLoading={isEventLoading}
      setSelectedDate={handleSelectedDateChange}
      setSelectedCandidate={setSelectedCandidate}
    />
  );

  // const onlineMeetingUrlRef = createRef<HTMLDivElement>();
  // const copyOnlineMeetingUrlToClipBoard = () => {
  //   Utils.copyElementToClipBoard(onlineMeetingUrlRef.current, false);
  //   contextValue.setSnackbarContent({
  //     message: 'Web会議リンクをクリップボードにコピーしました',
  //     severity: 'success'
  //   });
  //   contextValue.setOpenSnackbar(true);
  // };

  // const ReAuthBackdrop = () => (
  //   <AuthBackdrop open={needReAuth}>
  //     <Box>
  //       <Typography style={{ textAlign: 'center' }}>
  //         {disconnectedAccounts.map((da, i) => (
  //           <p key={i}>
  //             {da.message
  //               ? `Google Calendar(${da.email})への${da.message}`
  //               : `Google Calendar(${da?.email})との連携が解除されています`}
  //           </p>
  //         ))}
  //       </Typography>
  //       <TheReAuthButton
  //         variant="contained"
  //         color="primary"
  //         style={{
  //           display: 'block',
  //           margin: '12px auto 0',
  //           textTransform: 'none'
  //         }}
  //         onClick={() => {
  //           location.href = history.createHref({ pathname: '/auth/new' });
  //         }}
  //       >
  //         Google Calendarと再連携
  //       </TheReAuthButton>
  //     </Box>
  //   </AuthBackdrop>
  // );

  return (
    <Wrapper
      style={{
        maxWidth: contextValue.isMobile ? '100vw' : 'auto',
        minHeight: 'calc(100vh - 54px)'
      }}
    >
      {/* <ReAuthBackdrop /> */}
      <TheLeft isMobile={contextValue.isMobile} withCalendar={contextValue.fixWithCalendar || false}>
        <Box
          style={{
            marginTop: '16px',
            maxHeight: `calc(100vh - 54px - 24px - 24px${contextValue.isMobile ? ' - 56px' : ''})`,
            overflowY: 'scroll'
          }}
        >
          {isLoadingOpenMeeting && (
            <Box textAlign="center">
              <CircularProgress />
            </Box>
          )}
          <Box marginBottom="20px" padding="0 20px">
            {openMeeting && (
              <>
                <Box>
                  <H2
                    style={{
                      margin: '0 auto 6px 0',
                      fontSize: '16px'
                    }}
                  >
                    {openMeeting.title}
                  </H2>
                </Box>
                <LeftInfoTable>
                  <LeftInfoTr>
                    <LeftInfoTh>
                      <TheInfoIcon>
                        <CalendarTodayIcon fontSize="small" />
                      </TheInfoIcon>
                      <span>候補日</span>
                    </LeftInfoTh>
                    <LeftInfoTd>
                      {/* {openMeeting.startTime && openMeeting.endTime ? (
                        <>
                          {openMeeting.startTime.format('MM月DD日 HH:mm 〜 ')}
                          {openMeeting.endTime.format('HH:mm')}
                        </>
                      ) : (
                        <>
                          {openMeeting.startDate().format('MM月DD日 〜 ')}
                          {openMeeting.lastStartDate().format('MM月DD日')}
                        </>
                      )} */}
                    </LeftInfoTd>
                  </LeftInfoTr>
                  <LeftInfoTr>
                    <LeftInfoTh>
                      <TheInfoIcon>
                        <AccessTimeIcon fontSize="small" />
                      </TheInfoIcon>
                      <span>時間</span>
                    </LeftInfoTh>
                    <LeftInfoTd>{`${openMeeting.duration || '- '}分`}</LeftInfoTd>
                  </LeftInfoTr>
                  <LeftInfoTr>
                    <LeftInfoTh>
                      <TheInfoIcon>
                        <PlaceIcon fontSize="small" />
                      </TheInfoIcon>
                      <span>場所</span>
                    </LeftInfoTh>
                    <LeftInfoTd>
                      {openMeeting.meetingType && openMeeting.meetingType !== 'none'
                        ? 'オンライン'
                        : openMeeting?.place || openMeeting?.placeAddress}
                    </LeftInfoTd>
                  </LeftInfoTr>
                </LeftInfoTable>
              </>
            )}
            {openMeetingError && <Box color="red">{openMeetingError}</Box>}
          </Box>
          {openMeeting && (
            <LeftCandidateBox>
              <LeftCandidateTitle>候補を選択</LeftCandidateTitle>
              {renderCandidatesArea()}
              <LeftButtonWrapper isMobile={contextValue.isMobile}>
                {contextValue.isMobile && contextValue.fixWithCalendar && (
                  <LeftButtonSideText>
                    {selectedCandidate ? (
                      <>{selectedCandidate.start.format('MM/DD (ddd) HH:mm -')}</>
                    ) : (
                      <>候補日：未選択</>
                    )}
                  </LeftButtonSideText>
                )}
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  disabled={!selectedCandidate || isSubmitting}
                  onClick={() => handleConfirmDialogToggle(true)}
                >
                  この日時で確定する
                </Button>
                {/* {contextValue.isMobile && showConfirmDialog ? (
                  <Button
                    variant="contained"
                    fullWidth
                    color="primary"
                    disabled={!selectedCandidate || isSubmitting || !isInputDestination()}
                    onClick={() => handleSubmit()}
                    style={{ margin: '0 auto' }}
                  >
                    確定
                  </Button>
                ) : (
                  <>
                  </>
                )} */}
                {isSubmitting && <ButtonProgress />}
              </LeftButtonWrapper>
              {submitError && <Error color="error">{submitError}</Error>}
            </LeftCandidateBox>
          )}
          {/* {!isLoading && contextValue.isMobile && !contextValue.user && (
            <LeftSignupBox>
              <LeftSignupRibon>
                <img src="/images/aicalendar/logo_ribon01.png" width="82" height="80" />
              </LeftSignupRibon>
              <LeftSignupBoxIn>
                <LeftSignupTitle>AIカレンダーに登録またはログイン</LeftSignupTitle>
                <Button
                  style={{ display: 'block', margin: '5px 0 0 -10px' }}
                  onClick={() => {
                    location.href = contextValue.googleOauthPath;
                  }}
                >
                  <img src="/images/sign_in_with_google.png" width="191" />
                </Button>
                <Button
                  style={{ display: 'block', margin: '-5px 0 0 -7px' }}
                  onClick={() => {
                    location.href = contextValue.outlookOauthPath;
                  }}
                >
                  <img src="/images/sign_in_with_microsoft.png" width="215" />
                </Button>
              </LeftSignupBoxIn>
            </LeftSignupBox>
          )} */}
          {selectedCandidate && (
            <FixAdjustmentDialog
              show={showConfirmDialog}
              onClose={() => handleConfirmDialogToggle(false)}
              startTime={selectedCandidate.start}
              endTime={selectedCandidate.end}
              onSubmit={handleSubmit}
              isSubmitting={isSubmitting}
              errorMessage={submitError}
            />
          )}
        </Box>
      </TheLeft>
      <TheRight isMobile={contextValue.isMobile} withCalendar={contextValue.fixWithCalendar || false}>
        {renderBigCalendar()}
        {/* {renderPromotionDialog()} */}
      </TheRight>
    </Wrapper>
  );
});

// const PromotionWrap = styled(Box)`
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
// `;

// const CloseButton = styled(CancelIcon)`
//   color: #ddd;
//   font-size: 20px;
// `;

// const PromotionTit = styled(Typography)`
//   font-size: 15px;
//   font-weight: bold;
//   line-height: 1.6;
// `;

// const PromotionTxt = styled(Typography)`
//   font-size: 11px;
//   line-height: 1.8;
// `;

// const PromotionTxtSub = styled(PromotionTxt)`
//   color: #606060;
// `;

// export const TheCard = styled(Card)`
//   padding: 24px;
//   margin-bottom: 32px;
// `;

// export const CardTitle = styled(Typography).attrs({ variant: 'h3' })`
//   margin-bottom: 24px;
//   padding-top: 9px;
//   font-size: 24px;
//   line-height: 32px;
//   font-weight: 500;
// `;

// export const TheDescription = styled(Typography)`
//   font-size: 16px;
//   line-height: 28px;
// `;

const Error = styled(Typography).attrs(() => ({ color: 'error' }))`
  margin-top: 12px;
`;

// export const IconArea = styled(Box)`
//   min-width: 33px;
//   padding-top: 5px;
// `;

// export const TheInputLabel = styled(InputLabel)`
//   margin-bottom: 8px;
//   font-size: 16px;
//   line-height: 28px;
// `;

// export const NameField = styled(FilledTextField)`
//   width: 280px;
// `;

// const TheInfoItem = styled.div<{ isMobile: boolean }>`
//   display: flex;
//   align-items: center;
//   box-sizing: border-box;
//   width: 190px;
//   margin-bottom: 10px;
//   padding: 6px;

//   ${props =>
//     props.isMobile &&
//     `
//     margin-bottom: 0;
//   `}
// `;

// const FixedInfoLabel = styled.div`
//   color: #909090;
//   font-size: 10px;
// `;

// const FixedInfoText = styled(Typography)`
//   margin-left: 10px;
//   font-size: 12px;

//   svg {
//     vertical-align: middle;
//     margin-left: 3px;
//     font-size: 13px;
//   }
// `;

// const FixedInfoNote = styled(Box)`
//   margin: 10px 0 0;
// `;

// const FixedContentButtonWrap = styled(Box)`
//   padding: 0 40px 20px;
//   text-align: center;
// `;

// const FixedFoot = styled(Box)`
//   background: #f9f9f9;
//   text-align: center;
// `;

// const FixedFootHead = styled(Box)`
//   display: flex;
//   align-items: center;
//   margin-bottom: 15px;
// `;

// const FixedFootImg = styled(Box)`
//   margin-right: 10px;
// `;

// const FixedFootTitle = styled(Box)``;

// const FixedFootTitleTop = styled(Typography)`
//   color: ${muiTheme.palette.primary.main};
//   font-size: 14px;
//   font-weight: bold;
// `;

// const FixedFootTitleBelow = styled(FixedFootTitleTop)`
//   margin-top: 3px;
//   font-size: 13px;
// `;

// const FixedFootText = styled(Typography)`
//   font-size: 10px;
// `;

const TheLeft = styled(Left)<{ isMobile: boolean; withCalendar: boolean }>`
  width: 280px;
  margin: 0;
  padding-bottom: 24px;
  border-top: solid 10px ${muiTheme.palette.primary.main};
  border-right: solid 1px ${props => props.theme.grayBorderColor};

  ${props =>
    props.isMobile &&
    `
    max-height: calc(100vh - 54px);

    ${
      props.withCalendar
        ? `
      width: 0;
      overflow: hidden;
    `
        : `
      width: 100vw;
    `
    }
  `}
`;

// const LeftStatus = styled(Typography).attrs(() => ({ color: 'error' }))`
//   margin-bottom: 20px;
//   font-size: 12px;
//   font-weight: bold;
// `;

const LeftInfoTable = styled.table``;

const LeftInfoTr = styled.tr``;

const LeftInfoTh = styled.th`
  padding: 6px 0;
  color: #909090;
  font-size: 10px;
  text-align: left;
`;

const LeftInfoTd = styled.td`
  padding: 6px;
  vertical-align: middle;
  font-size: 12px;
`;

const TheInfoIcon = styled.span`
  display: inline-block;
  vertical-align: middle;
  height: 20px;
  margin-right: 4px;
`;

const LeftCandidateBox = styled(Box)``;

const LeftCandidateTitle = styled(Typography)`
  padding: 10px 17px;
  background: #f9f9f9;
  border-left: solid 3px ${muiTheme.palette.primary.main};
  font-size: 12px;
  line-height: 1;
`;

const LeftButtonWrapper = styled(ButtonWrapper)<{ isMobile: boolean }>`
  box-sizing: border-box;
  width: 100%;
  padding: 0 24px;

  ${props =>
    props.isMobile &&
    `
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 90;
    padding: 10px 24px;
    background: #f9f9f9;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
  `}
`;

const LeftButtonSideText = styled(Typography)`
  width: 100%;
  font-size: 14px;
  font-weight: 700;
`;

// const LeftSignupBox = styled(Box)`
//   position: relative;
//   padding: 5px 22px 20px;
// `;

// const LeftSignupRibon = styled(Box)`
//   position: absolute;
//   top: 0;
//   right: 17px;
//   width: 82px;
//   height: 80px;
// `;

// const LeftSignupBoxIn = styled(Box)`
//   padding: 20px 22px;
//   background: #f9f9f9;
//   border-radius: 10px;
// `;

// const LeftSignupTitle = styled(Typography)`
//   color: ${muiTheme.palette.primary.main};
//   font-size: 14px;
//   font-weight: bold;
// `;

const TheRight = styled(Right)<{ isMobile: boolean; withCalendar: boolean }>`
  position: relative;
  height: 100%;
  padding: 12px 20px 0 24px;

  .rbc-toolbar button {
    padding: 0.275rem 1rem;
  }

  ${props =>
    props.isMobile &&
    `
    max-height: calc(100vh - 54px);
    padding: 0 6px;
    border-left: 0;

    ${
      props.withCalendar
        ? `
      width: 100vw;
    `
        : `
      width: 0;
      overflow: hidden;
    `
    }
  `}
`;

// export const AutocompleteBox = styled.div<{ withAlert?: string }>`
//   width: 100%;
//   .MuiAutocomplete-inputRoot.MuiFilledInput-root {
//     padding-top: 6px;
//   }

//   ${props =>
//     props.withAlert === 'true' &&
//     `
//     input::placeholder {
//       color: ${muiTheme.palette.error.main};
//       opacity: 1;
//     }
//     .MuiInput-underline:before {
//       border-bottom-color: ${muiTheme.palette.error.main};
//     }
//   `}
// `;

// const ButtonIcon = styled.span`
//   display: inline-block;
//   margin-right: 4px;
// `;

// const CopyIconWrap = styled(Box)`
//   min-width: 36px;
//   margin-bottom: auto;
//   background: #fff;
//   box-shadow: -21px 0px 20px 20px #fff;
// `;

// const CopyIconButton = styled(IconButton)`
//   padding: 8px;
//   background: ${muiTheme.palette.primary.main};
//   box-shadow: 0 0 6px -2px #000;
//   border-radius: 50%;
//   line-height: 1;
//   transform: rotateX(180deg);
// `;

// const OnlineMeetingUrl = styled.div`
//   display: flex;
//   flex-wrap: nowrap;
//   align-items: center;
// `;

// const OnlineMeetingUrlText = styled(Typography)`
//   overflow: hidden;
//   white-space: nowrap;
//   font-size: 12px;
// `;

// const ShareUsesrListBox = styled(Box)<{ isMobile: boolean }>`
//   margin: 20px 20px 10px 20px;
//   width: 347px;

//   ${props =>
//     props.isMobile &&
//     `
//     margin: 0;
//     width: 100%;
//   `}
// `;

// const ShareUsesrListText = styled(Typography)<{ isMobile: boolean }>`
//   font-size: 14px;
//   font-weight: bold;

//   ${props =>
//     props.isMobile &&
//     `
//     font-size: 12px;
//   `}
// `;

// const ShareUsesrListLabel = styled(Typography)<{ isMobile: boolean }>`
//   font-size: 12px;
//   font-weight: bold;

//   ${props =>
//     props.isMobile &&
//     `
//     font-size: 10px;
//   `}
// `;

export default OpenMeetingsShow;
